const METADATA = Object.freeze({
  CONTENT_URI: '-',
  SCHEMA_URI: 'Custom',
  SCHEMA_VERSION: '1.0.0',
});

export default Object.freeze({
  METADATA,
});
